function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#pure_to_pure);}.cls-2{fill:url(#pure_to_pure-2);}.cls-3{fill:url(#pure_to_pure-3);}.cls-4{fill:url(#pure_to_pure-4);}.cls-5{fill:url(#pure_to_pure-5);}.cls-6{fill:url(#pure_to_pure-6);}.cls-7{fill:url(#pure_to_pure-7);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure",
  x1: 124.96,
  y1: 250,
  x2: 303,
  y2: 250,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1fc3f3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4cbfac"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure-2",
  x1: 124.96,
  y1: 106.53,
  x2: 303,
  y2: 106.53,
  xlinkHref: "#pure_to_pure"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure-3",
  x1: 124.96,
  y1: 293.48,
  x2: 303,
  y2: 293.48,
  xlinkHref: "#pure_to_pure"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure-4",
  x1: 124.96,
  y1: 230.92,
  x2: 303,
  y2: 230.92,
  xlinkHref: "#pure_to_pure"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure-5",
  x1: 124.96,
  y1: 168.35,
  x2: 303,
  y2: 168.35,
  xlinkHref: "#pure_to_pure"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure-6",
  x1: 124.96,
  y1: 399.84,
  x2: 303,
  y2: 399.84,
  xlinkHref: "#pure_to_pure"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure-7",
  x1: 124.96,
  y1: 284.65,
  x2: 303,
  y2: 284.65,
  xlinkHref: "#pure_to_pure"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M235.07,336.58l-1.8-1.38V67.37a47.37,47.37,0,0,0-94.74,0v268l-1.72,1.39a80.89,80.89,0,0,0-31,63.13A80.13,80.13,0,0,0,185.9,480h0a80.14,80.14,0,0,0,49.15-143.42Zm2.19,95.75a60.41,60.41,0,0,1-51.35,28.29h0a60.9,60.9,0,0,1-60.75-60.74c0-20.13,10.66-39.38,28.51-51.49a9.64,9.64,0,0,0,4.26-8v-273a28,28,0,1,1,56,0v273a9.55,9.55,0,0,0,4.49,8.19A60.8,60.8,0,0,1,237.26,432.33Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M385.11,114.92a9.13,9.13,0,0,0,0-18.26H277.37a9.13,9.13,0,1,0,0,18.26v0Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M327.49,284.36H277.37a9.13,9.13,0,0,0-6.46,15.58,9,9,0,0,0,6.45,2.67H327.5a9.13,9.13,0,1,0,0-18.25Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M385.11,221.79H277.37a9.13,9.13,0,1,0,0,18.26H385.11a9.13,9.13,0,0,0,0-18.26Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M277.37,177.48h50.12a9.13,9.13,0,0,0,9.12-9.13,9.1,9.1,0,0,0-9.12-9.12H277.36a9.13,9.13,0,0,0,0,18.25Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1200",
  "data-name": "Path 1200",
  className: "cls-6",
  d: "M178.66,371a29.33,29.33,0,1,0,15.74.35Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1201",
  "data-name": "Path 1201",
  className: "cls-7",
  d: "M194.52,410.07V168.48c0-5.11-3.86-9.25-8.62-9.25s-8.62,4.14-8.62,9.25V409.64Z"
});

var SvgIconTemperature = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTemperature, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_temperature.34ae52ca.svg";
export { ForwardRef as ReactComponent };